'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import SectionLabel from '../home/SectionLabel';
import { useTranslation } from '@/i18n/client';
import { HiBuildingStorefront, HiChartBar, HiPaintBrush, HiQrCode, HiShare, HiSparkles } from 'react-icons/hi2';

type Props = { lang: Locale };

type Key = 'qr' | 'themes' | 'brand' | 'share' | 'stats' | 'capture';

const ITEMS: { key: Key; Icon: typeof HiQrCode }[] = [
  { key: 'qr', Icon: HiQrCode },
  { key: 'themes', Icon: HiSparkles },
  { key: 'brand', Icon: HiPaintBrush },
  { key: 'share', Icon: HiShare },
  { key: 'stats', Icon: HiChartBar },
  { key: 'capture', Icon: HiBuildingStorefront },
];

const DiscoverBcCapabilities = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const label = t('DiscoverBc/Capabilities/badge');
  const headlineA = t('DiscoverBc/Capabilities/title1');
  const headlineB = t('DiscoverBc/Capabilities/title2');
  const sub = t('DiscoverBc/Capabilities/subtitle');

  return (
    <section
      id="capabilities"
      className="px-6 py-24 lg:py-28"
      style={{
        background: '#0E1130',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        color: '#F5F7FA',
      }}
    >
      <div className="mx-auto max-w-[1200px]">
        <SectionLabel num="02" label={label} />
        <h2
          className="font-bold tracking-tight"
          style={{
            fontSize: 'clamp(28px, 3.4vw, 48px)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            margin: '12px 0 14px',
            maxWidth: 820,
          }}
        >
          {headlineA} <span style={{ color: '#B4C1D8' }}>{headlineB}</span>
        </h2>
        <p
          style={{
            color: '#B4C1D8',
            fontSize: 18,
            maxWidth: 720,
            lineHeight: 1.5,
            margin: '0 0 48px',
          }}
        >
          {sub}
        </p>

        <div className="grid gap-5" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
          {ITEMS.map(({ key, Icon }) => {
            return (
              <article
                key={key}
                className="rounded-2xl p-6"
                style={{
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <div
                  className="inline-flex items-center justify-center rounded-lg mb-4"
                  style={{
                    width: 40,
                    height: 40,
                    background: 'rgba(167,139,250,0.12)',
                    border: '1px solid rgba(167,139,250,0.30)',
                  }}
                >
                  <Icon style={{ width: 20, height: 20, color: '#A78BFA' }} />
                </div>
                <h3
                  className="font-semibold"
                  style={{
                    fontSize: 18,
                    color: '#F5F7FA',
                    margin: '0 0 8px',
                    letterSpacing: '-0.01em',
                  }}
                >
                  {t(`DiscoverBc/Capabilities/${key}/title`)}
                </h3>
                <p
                  style={{
                    color: '#B4C1D8',
                    fontSize: 14,
                    lineHeight: 1.55,
                    margin: 0,
                  }}
                >
                  {t(`DiscoverBc/Capabilities/${key}/body`)}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DiscoverBcCapabilities;
